


















































































import { Component, Vue, Mixins } from "vue-property-decorator";
import store from "@/store";
import router from "@/router/router";
import getUrlParam from '@/common/utils/getUrlParam';
import { Getter, Action } from "vuex-class";

@Component
export default class PlayExplanation extends Vue {
  @Getter("gachaTypeParameter") gachaTypeParameter!: object;
  @Action("changeGachaParameter") changeGachaParameter!: Function;
  getUrlParam: Function = getUrlParam;
  get sectionConf() {
    return store.getters.section;
  }

  getIsShowStr(){
    const isShowStr = window.location.href.indexOf("explanation") ? 'block':'none';
    return isShowStr;
  }

  goBack() {
    this.changeGachaParameter({'showPlayDesc':false});
  }

  togglePlayType(type:string){
    store.dispatch("togglePlayType",type);
  }
}
